import * as React from 'react'
import dynamic from 'next/dynamic'

import {t} from '@lib/helpers'
import {
  Architecture,
  Capability,
  Certification,
  Header,
  Industry,
  Stat,
  UseCase,
} from '@components/partner-aws'

const Meta = dynamic(() => import('@components/Meta'))

export default function PartnerAws() {
  return (
    <React.Fragment>
      <Meta
        title={t('pages.partnerAws.metadata.title')}
        description={t('pages.partnerAws.metadata.description')}
      />
      <main className='PartnerAws'>
        <Header />
        <Stat />
        <Certification />
        <Capability />
        <Architecture />
        <Industry />
        <UseCase />
      </main>
    </React.Fragment>
  )
}
